var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cssProps)},[_c('form',{staticClass:"paymentWidgets",attrs:{"action":_vm.formActionUrl,"data-brands":"VISA MASTER"}})])}
var staticRenderFns = []

export { render, staticRenderFns }